// TTL curto e conservador: cobre montagens duplicadas/StrictMode sem persistir dados financeiros.
export const COMPETENCIAS_CACHE_TTL_MS = 15000;

export const normalizarVinculosCompetencias = (vinculos = []) => (Array.isArray(vinculos) ? vinculos : [])
    .map((vinculo) => ({
        matricula: String(
            vinculo?.matricula || vinculo?.vinc_matricula || vinculo?.matriculaServidor || vinculo?.vinculo_matricula || ''
        ).trim(),
        vinculoId: String(vinculo?.v_vinculo_id || vinculo?.vinculo_id || vinculo?.vinculoId || '').trim(),
        servidorDocId: String(vinculo?.id || vinculo?.servidorDocId || '').trim(),
    }))
    .filter((vinculo) => vinculo.matricula || vinculo.vinculoId || vinculo.servidorDocId);

export const fingerprintVinculosCompetencias = (vinculos = []) => JSON.stringify(
    normalizarVinculosCompetencias(vinculos)
        .map(({ matricula, vinculoId, servidorDocId }) => [matricula, vinculoId, servidorDocId])
        .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)))
);



// Metadados do catálogo não contêm valores financeiros e podem ficar em memória
// por um intervalo curto para evitar leituras duplicadas entre cards/páginas.
export const CATALOGO_CONTRACHEQUE_CACHE_TTL_MS = 60000;

export const chaveCacheCatalogoContrachequeServidor = ({ uid, municipioId }) => JSON.stringify([
    String(uid || ''),
    String(municipioId || ''),
]);

export const chaveCacheCompetenciasServidor = ({ uid, municipioId, cpf, vinculos }) => JSON.stringify([
    String(uid || ''),
    String(municipioId || ''),
    String(cpf || '').replace(/\D/g, ''),
    fingerprintVinculosCompetencias(vinculos),
]);

export const criarCacheSingleFlight = ({ ttlMs = COMPETENCIAS_CACHE_TTL_MS, now = () => Date.now() } = {}) => {
    const entries = new Map();
    return {
        run(key, loader) {
            const existente = entries.get(key);
            if (existente?.promise) return existente.promise;
            if (existente && existente.expiresAt > now()) return Promise.resolve(existente.value);
            if (existente) entries.delete(key);

            const promise = Promise.resolve()
                .then(loader)
                .then((value) => {
                    entries.set(key, { value, expiresAt: now() + ttlMs });
                    return value;
                })
                .catch((error) => {
                    entries.delete(key);
                    throw error;
                });
            entries.set(key, { promise });
            return promise;
        },
        clear() {
            entries.clear();
        },
    };
};

export const cacheCompetenciasServidor = criarCacheSingleFlight();
export const cacheCatalogoContrachequeServidor = criarCacheSingleFlight({ ttlMs: CATALOGO_CONTRACHEQUE_CACHE_TTL_MS });
